const context = require.context('./2024/fall', true, /\/details\.js$/);

const featuredItems = context.keys().map(key => {
  const id = key.split('/')[1];
  const details = context(key).default;
  return {
    id,
    ...details,
    image: details.slideImage
  };
});

export default featuredItems;